import { useContext } from "react";
import { purchaseOrdersContext } from "../../contexts/PurchaseOrdersContext";
import PurchaseOrderRow from "./PurchaseOrderRow";
import PurchaseOrderFilters from "./PurchaseOrderFilters";
import PurchaseOrdersExportConsumptionPerMonth from "./PurchaseOrdersExportConsumptionPerMonth";
import Spinner from "../Spinner";
import Error from "../Alerts/Error";
import SortableHeader from "../SortableHeader";
import { SortContext } from "../../contexts/SortContext";

function PurchaseOrders() {
	const {purchaseOrders, filters, setFilters, billingEntities, loading, error, sortBy, asc, desc, setSortBy, setAsc, setDesc} = useContext(purchaseOrdersContext);

    const purchaseOrdersWithBillingEntity = purchaseOrders.map(purchaseOrder => {
        const billingEntity = billingEntities.find(billingEntity => billingEntity.id === purchaseOrder.billingEntityId);
        return { ...purchaseOrder, billingEntity };
    })

    const handleExportPurchaseOrders = () => {
        const headers = ['Number', 'Customer', 'Description', 'Billing entity', 'Total value', 'Currency', 'Value consumed', 'Value remaining', 'Comments'];
        
        const tsvContent = [
            headers.join('\t'), 
            ...purchaseOrdersWithBillingEntity.map(purchaseOrder => [
                purchaseOrder.number,
                purchaseOrder.customer.firstName,
                purchaseOrder.description,
                purchaseOrder.billingEntity?.name,
                purchaseOrder.totalValue.toFixed(2),
                purchaseOrder.currency?.name,
                purchaseOrder.valueConsumed.toFixed(2),
                purchaseOrder.valueRemaining.toFixed(2),
                purchaseOrder.comments
            ].join('\t'))
        ].join('\n');
        
        const blob = new Blob([tsvContent], { type: 'text/tab-separated-values' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Accounting_export_POs_${new Date().toISOString().split('T')[0]}.tsv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

	return (
        <SortContext.Provider value={{sortBy, asc, desc, setSortBy, setAsc, setDesc}}>
            <div>
                <PurchaseOrdersExportConsumptionPerMonth />
                <PurchaseOrderFilters filters={filters} setFilters={setFilters} billingEntities={billingEntities} />
                <div className={"m-2 border p-4 bg-white shadow-sm"}>
                    <button className={"btn btn-primary mb-2"} onClick={handleExportPurchaseOrders}>Export purchase orders</button>
                    <div className={"table-responsive overflow-auto"}>
                        {error && <Error message={error} />}
                        <table className={"table table-striped table-bordered mt-2"} id={"resizeMe"}>
                            <thead className={"table-light"}>
                            <tr>
                                <SortableHeader columnName={"number"} text={"Number"} />
                                <SortableHeader columnName={"customer"} text={"Customer"} />
                                <th>Description</th>
                                <SortableHeader columnName={"billingEntity"} text={"Billing entity"} />
                                <SortableHeader columnName={"totalValue"} text={"Total value"} />
                                <th>Currency</th>
                                <th>Reference PDF</th>
                                <SortableHeader columnName={"valueConsumed"} text={"Value consumed"} />
                                <SortableHeader columnName={"valueRemaining"} text={"Value remaining"} />
                                <th>Comments</th>
                            </tr>
                            </thead>
                            <tbody>
                            {loading && <tr><td colSpan={6}><Spinner /></td></tr>}
                            {!loading && purchaseOrdersWithBillingEntity.map(value => {
                                return <PurchaseOrderRow purchaseOrder={value} key={value.id} />;
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </SortContext.Provider>
        
	)
}

export default PurchaseOrders;
